////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////
// noinspection UnnecessaryLocalVariableJS

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, {AxiosError} from 'axios';
import type {AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';
import {
  CreateCustomerRequest,
  CreateJobRequest,
  CreateOutgoingWebhookRequest,
  CreateProjectWiseConfigurationDto,
  CreateProjectWiseCredentialDto,
  CustomerInfo,
  DeckardAuthData,
  DetailedUsage,
  DownloadDto,
  EditCustomerRequest,
  EditJobRequest,
  EditOutgoingWebhookRequest,
  FileStatus,
  GDPRWebhook,
  GDPRWebhookResponse,
  HealthStatus,
  Hub,
  Job,
  JobRun,
  JobRunItemStatusType,
  JobRunStatusType,
  OutgoingWebhook,
  OutgoingWebhookBody,
  OutgoingWebhookEventPaginatedResult,
  OutgoingWebhookPaginatedResult,
  OutgoingWebhookSecret,
  OutgoingWebhookSendAttempt,
  ProblemDetails,
  Project,
  ProjectWiseConfiguration,
  ProjectWiseConfigurationPaginatedResult,
  ProjectWiseCredential,
  ProjectWiseCredentialPaginatedResult,
  ProjectWiseCredentialWithSecret,
  StartExtractRequest,
  StartExtractResponse,
  StartUsageDownloadResult,
  StorageType,
  UpdateProjectWiseConfigurationDto,
  UpdateProjectWiseCredentialDto,
  UsageExportFormat,
  UsageExportType,
  UsageSortType,
  UsageSummary,
  UserAccount,
  UserBase,
  WebhookBody,
  ZipEntryDto
} from "./Classes";

export interface IClient {
  callback(code?: string | undefined, callbackUrlOverride?: string | null | undefined): Promise<DeckardAuthData>;

  refreshToken(userId: string, refreshToken: string): Promise<DeckardAuthData>;

  createJob(createJobRequest?: CreateJobRequest | null | undefined): Promise<Job>;

  getJobs(): Promise<Job[]>;

  deleteJob(id: string): Promise<void>;

  editJob(id: string, dto?: EditJobRequest | null | undefined): Promise<Job>;

  getJob(id: string, loadFilesAndFolders?: boolean | undefined, loadItems?: boolean | undefined): Promise<Job>;

  getJobRun(jobRunId: string): Promise<JobRun>;

  startJob(jobId: string): Promise<JobRun>;

  getDetailedUsage(statuses?: JobRunItemStatusType[] | undefined, limit?: number | null | undefined, paginationToken?: string | null | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined): Promise<DetailedUsage>;

  getCsvDownload(id?: string | undefined): Promise<DownloadDto>;

  getUsageDownload(id?: string | undefined): Promise<DownloadDto>;

  getUsageSummary(statuses?: JobRunStatusType[] | undefined, includeRuns?: boolean | undefined, limit?: number | null | undefined, paginationToken?: string | null | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined): Promise<UsageSummary>;

  startCsvDownload(filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined): Promise<StartUsageDownloadResult>;

  startUsageDownload(filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined): Promise<StartUsageDownloadResult>;

  createWebhook(createWebhookDto?: CreateOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhook>;

  listWebhooks(isDeleted?: boolean | null | undefined, paginationToken?: string | null | undefined, limit?: number | null | undefined): Promise<OutgoingWebhookPaginatedResult>;

  deleteUserWebhooks(): Promise<void>;

  deleteUserWebhooksAdmin(userId: string): Promise<void>;

  deleteWebhook(id: string): Promise<void>;

  editWebhook(id: string, dto?: EditOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhook>;

  getWebhook(id: string): Promise<OutgoingWebhook>;

  deleteWebhookAdmin(userId: string, id: string): Promise<void>;

  editWebhookAdmin(userId: string, id: string, dto?: EditOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhook>;

  getWebhookSecret(id: string): Promise<OutgoingWebhookSecret>;

  listUserWebhookHistories(isDeleted?: boolean | null | undefined, paginationToken?: string | null | undefined, limit?: number | null | undefined): Promise<OutgoingWebhookEventPaginatedResult>;

  listWebhookHistory(id: string, paginationToken?: string | null | undefined, limit?: number | null | undefined): Promise<OutgoingWebhookEventPaginatedResult>;

  listWebhooksAdmin(userId: string, isDeleted?: boolean | null | undefined, paginationToken?: string | null | undefined, limit?: number | null | undefined): Promise<OutgoingWebhookPaginatedResult>;

  previewExistingWebhookBody(id: string, dto?: EditOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhookBody>;

  previewWebhookBody(createWebhookDto?: CreateOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhookBody>;

  testExistingWebhook(id: string, dto?: EditOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhookSendAttempt>;

  testNewWebhook(createWebhookDto?: CreateOutgoingWebhookRequest | null | undefined): Promise<OutgoingWebhookSendAttempt>;

  /**
   * Lists the contents of a ZIP file.
   * @param projectId The project id.
   * @param fileId The file id.
   * @param storageType (optional) The storage type. Defaults to Forge.
   * @param allowDeleted (optional) Whether to list a deleted file's contents.
   * @return The list of files contained in the ZIP.
   */
  listZipContents(projectId: string, fileId: string, storageType?: StorageType | undefined, allowDeleted?: boolean | undefined): Promise<ZipEntryDto[]>;

  /**
   * Extracts the contents of a ZIP file.
   * @param extractRequest (optional) The parameters for the extraction job.
   * @return A list of status objects for the job.
   */
  startExtract(extractRequest?: StartExtractRequest | null | undefined): Promise<StartExtractResponse[]>;

  /**
   * Gets the status of an extraction job.
   * @param id The job ID.
   * @return The current status of the job.
   */
  status(id: string): Promise<FileStatus>;

  createCustomer(dto?: CreateCustomerRequest | null | undefined): Promise<CustomerInfo>;

  /**
   * @deprecated
   */
  listCustomers(): Promise<CustomerInfo[]>;

  deleteCustomer(id: string): Promise<void>;

  getCustomer(id: string): Promise<CustomerInfo>;

  updateCustomer(id: string, dto?: EditCustomerRequest | null | undefined): Promise<void>;

  heartbeat(): Promise<HealthStatus>;

  getProject(hubId: string | null, projectId: string, storageType?: StorageType | null | undefined): Promise<Project>;

  listAll(includeLegacyHubs?: boolean | undefined): Promise<Project[]>;

  listHubs(includeLegacyHubs?: boolean | undefined): Promise<Hub[]>;

  listImages(includeLegacyHubs?: boolean | undefined): Promise<Project[]>;

  createProjectWiseConfiguration(dto?: CreateProjectWiseConfigurationDto | null | undefined): Promise<ProjectWiseConfiguration>;

  createProjectWiseCredential(dto?: CreateProjectWiseCredentialDto | null | undefined): Promise<ProjectWiseCredential>;

  listProjectWiseCredentials(paginationToken?: string | null | undefined, limit?: number | undefined): Promise<ProjectWiseCredentialPaginatedResult>;

  deleteProjectWiseConfiguration(id: string): Promise<void>;

  getProjectWiseConfiguration(id: string, allowDeleted?: boolean | undefined): Promise<ProjectWiseConfiguration>;

  updateProjectWiseConfiguration(id: string, dto?: UpdateProjectWiseConfigurationDto | null | undefined): Promise<ProjectWiseConfiguration>;

  deleteProjectWiseCredential(id: string): Promise<void>;

  getProjectWiseCredential(id: string, allowDeleted?: boolean | undefined): Promise<ProjectWiseCredential>;

  updateProjectWiseCredential(id: string, dto?: UpdateProjectWiseCredentialDto | null | undefined): Promise<ProjectWiseCredential>;

  getProjectWiseCredentialSecret(id: string): Promise<ProjectWiseCredentialWithSecret>;

  listProjectWiseConfigurations(paginationToken?: string | null | undefined, limit?: number | undefined): Promise<ProjectWiseConfigurationPaginatedResult>;

  listStorageTypes(): Promise<string[]>;

  getUserAccounts(): Promise<UserAccount[]>;

  getUserInfo(): Promise<UserBase>;

  userWebhookCallback(webhookBody?: GDPRWebhook | null | undefined, signature?: string | undefined): Promise<GDPRWebhookResponse>;

  adskWebhookCallback(webhookBody?: WebhookBody | null | undefined, signature?: string | null | undefined, userId?: string | null | undefined): Promise<void>;
}

export class Client implements IClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {

    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";

  }

  callback(code?: string | undefined, callbackUrlOverride?: string | null | undefined, cancelToken?: CancelToken): Promise<DeckardAuthData> {
    let url_ = this.baseUrl + "/api/v1/auth/callback?";
    if (code === null)
      throw new Error("The parameter 'code' cannot be null.");
    else if (code !== undefined)
      url_ += "code=" + encodeURIComponent("" + code) + "&";
    if (callbackUrlOverride !== undefined && callbackUrlOverride !== null)
      url_ += "callbackUrlOverride=" + encodeURIComponent("" + callbackUrlOverride) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processCallback(_response);
    });
  }

  protected processCallback(response: AxiosResponse): Promise<DeckardAuthData> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DeckardAuthData.fromJS(resultData200);
      return Promise.resolve<DeckardAuthData>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DeckardAuthData>(null as any);
  }

  refreshToken(userId: string, refreshToken: string, cancelToken?: CancelToken): Promise<DeckardAuthData> {
    let url_ = this.baseUrl + "/api/v1/auth/refresh/{userId}/{refreshToken}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (refreshToken === undefined || refreshToken === null)
      throw new Error("The parameter 'refreshToken' must be defined.");
    url_ = url_.replace("{refreshToken}", encodeURIComponent("" + refreshToken));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRefreshToken(_response);
    });
  }

  protected processRefreshToken(response: AxiosResponse): Promise<DeckardAuthData> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DeckardAuthData.fromJS(resultData200);
      return Promise.resolve<DeckardAuthData>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DeckardAuthData>(null as any);
  }

  createJob(createJobRequest?: CreateJobRequest | null | undefined, cancelToken?: CancelToken): Promise<Job> {
    let url_ = this.baseUrl + "/api/v1/job";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createJobRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processCreateJob(_response);
    });
  }

  protected processCreateJob(response: AxiosResponse): Promise<Job> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = Job.fromJS(resultData201);
      return Promise.resolve<Job>(result201);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = ProblemDetails.fromJS(resultData422);
      return throwException("A server side error occurred.", status, _responseText, _headers, result422);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Job>(null as any);
  }

  getJobs(cancelToken?: CancelToken): Promise<Job[]> {
    let url_ = this.baseUrl + "/api/v1/job";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetJobs(_response);
    });
  }

  protected processGetJobs(response: AxiosResponse): Promise<Job[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(Job.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<Job[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Job[]>(null as any);
  }

  deleteJob(id: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/job/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteJob(_response);
    });
  }

  protected processDeleteJob(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  editJob(id: string, dto?: EditJobRequest | null | undefined, cancelToken?: CancelToken): Promise<Job> {
    let url_ = this.baseUrl + "/api/v1/job/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processEditJob(_response);
    });
  }

  protected processEditJob(response: AxiosResponse): Promise<Job> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = Job.fromJS(resultData200);
      return Promise.resolve<Job>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 422) {
      const _responseText = response.data;
      let result422: any = null;
      let resultData422 = _responseText;
      result422 = ProblemDetails.fromJS(resultData422);
      return throwException("A server side error occurred.", status, _responseText, _headers, result422);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Job>(null as any);
  }

  getJob(id: string, loadFilesAndFolders?: boolean | undefined, loadItems?: boolean | undefined, cancelToken?: CancelToken): Promise<Job> {
    let url_ = this.baseUrl + "/api/v1/job/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (loadFilesAndFolders === null)
      throw new Error("The parameter 'loadFilesAndFolders' cannot be null.");
    else if (loadFilesAndFolders !== undefined)
      url_ += "loadFilesAndFolders=" + encodeURIComponent("" + loadFilesAndFolders) + "&";
    if (loadItems === null)
      throw new Error("The parameter 'loadItems' cannot be null.");
    else if (loadItems !== undefined)
      url_ += "loadItems=" + encodeURIComponent("" + loadItems) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetJob(_response);
    });
  }

  protected processGetJob(response: AxiosResponse): Promise<Job> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = Job.fromJS(resultData200);
      return Promise.resolve<Job>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Job>(null as any);
  }

  getJobRun(jobRunId: string, cancelToken?: CancelToken): Promise<JobRun> {
    let url_ = this.baseUrl + "/api/v1/job/status/{jobRunId}";
    if (jobRunId === undefined || jobRunId === null)
      throw new Error("The parameter 'jobRunId' must be defined.");
    url_ = url_.replace("{jobRunId}", encodeURIComponent("" + jobRunId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetJobRun(_response);
    });
  }

  protected processGetJobRun(response: AxiosResponse): Promise<JobRun> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobRun.fromJS(resultData200);
      return Promise.resolve<JobRun>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobRun>(null as any);
  }

  startJob(jobId: string, cancelToken?: CancelToken): Promise<JobRun> {
    let url_ = this.baseUrl + "/api/v1/job/start/{jobId}";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processStartJob(_response);
    });
  }

  protected processStartJob(response: AxiosResponse): Promise<JobRun> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobRun.fromJS(resultData200);
      return Promise.resolve<JobRun>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobRun>(null as any);
  }

  getDetailedUsage(statuses?: JobRunItemStatusType[] | undefined, limit?: number | null | undefined, paginationToken?: string | null | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined, cancelToken?: CancelToken): Promise<DetailedUsage> {
    let url_ = this.baseUrl + "/api/v1/usage/detail?";
    if (statuses === null)
      throw new Error("The parameter 'statuses' cannot be null.");
    else if (statuses !== undefined)
      statuses && statuses.forEach(item => {
        url_ += "Statuses=" + encodeURIComponent("" + item) + "&";
      });
    if (limit !== undefined && limit !== null)
      url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "PaginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (filter_CustomerIds === null)
      throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
    else if (filter_CustomerIds !== undefined)
      filter_CustomerIds && filter_CustomerIds.forEach(item => {
        url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_UserIds === null)
      throw new Error("The parameter 'filter_UserIds' cannot be null.");
    else if (filter_UserIds !== undefined)
      filter_UserIds && filter_UserIds.forEach(item => {
        url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_JobIds === null)
      throw new Error("The parameter 'filter_JobIds' cannot be null.");
    else if (filter_JobIds !== undefined)
      filter_JobIds && filter_JobIds.forEach(item => {
        url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_StartTime !== undefined && filter_StartTime !== null)
      url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
    if (filter_EndTime !== undefined && filter_EndTime !== null)
      url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
    if (sort_SortType === null)
      throw new Error("The parameter 'sort_SortType' cannot be null.");
    else if (sort_SortType !== undefined)
      url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
    if (sort_Ascending === null)
      throw new Error("The parameter 'sort_Ascending' cannot be null.");
    else if (sort_Ascending !== undefined)
      url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
    if (exportType === null)
      throw new Error("The parameter 'exportType' cannot be null.");
    else if (exportType !== undefined)
      url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
    if (exportFormat === null)
      throw new Error("The parameter 'exportFormat' cannot be null.");
    else if (exportFormat !== undefined)
      url_ += "ExportFormat=" + encodeURIComponent("" + exportFormat) + "&";
    if (writeIfEmpty === null)
      throw new Error("The parameter 'writeIfEmpty' cannot be null.");
    else if (writeIfEmpty !== undefined)
      url_ += "WriteIfEmpty=" + encodeURIComponent("" + writeIfEmpty) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetDetailedUsage(_response);
    });
  }

  protected processGetDetailedUsage(response: AxiosResponse): Promise<DetailedUsage> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DetailedUsage.fromJS(resultData200);
      return Promise.resolve<DetailedUsage>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DetailedUsage>(null as any);
  }

  getCsvDownload(id?: string | undefined, cancelToken?: CancelToken): Promise<DownloadDto> {
    let url_ = this.baseUrl + "/api/v1/usage/csv/status?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetCsvDownload(_response);
    });
  }

  protected processGetCsvDownload(response: AxiosResponse): Promise<DownloadDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DownloadDto.fromJS(resultData200);
      return Promise.resolve<DownloadDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DownloadDto>(null as any);
  }

  getUsageDownload(id?: string | undefined, cancelToken?: CancelToken): Promise<DownloadDto> {
    let url_ = this.baseUrl + "/api/v1/usage/download/status?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetUsageDownload(_response);
    });
  }

  protected processGetUsageDownload(response: AxiosResponse): Promise<DownloadDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DownloadDto.fromJS(resultData200);
      return Promise.resolve<DownloadDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DownloadDto>(null as any);
  }

  getUsageSummary(statuses?: JobRunStatusType[] | undefined, includeRuns?: boolean | undefined, limit?: number | null | undefined, paginationToken?: string | null | undefined, filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined, cancelToken?: CancelToken): Promise<UsageSummary> {
    let url_ = this.baseUrl + "/api/v1/usage/summary?";
    if (statuses === null)
      throw new Error("The parameter 'statuses' cannot be null.");
    else if (statuses !== undefined)
      statuses && statuses.forEach(item => {
        url_ += "Statuses=" + encodeURIComponent("" + item) + "&";
      });
    if (includeRuns === null)
      throw new Error("The parameter 'includeRuns' cannot be null.");
    else if (includeRuns !== undefined)
      url_ += "IncludeRuns=" + encodeURIComponent("" + includeRuns) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "PaginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (filter_CustomerIds === null)
      throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
    else if (filter_CustomerIds !== undefined)
      filter_CustomerIds && filter_CustomerIds.forEach(item => {
        url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_UserIds === null)
      throw new Error("The parameter 'filter_UserIds' cannot be null.");
    else if (filter_UserIds !== undefined)
      filter_UserIds && filter_UserIds.forEach(item => {
        url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_JobIds === null)
      throw new Error("The parameter 'filter_JobIds' cannot be null.");
    else if (filter_JobIds !== undefined)
      filter_JobIds && filter_JobIds.forEach(item => {
        url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_StartTime !== undefined && filter_StartTime !== null)
      url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
    if (filter_EndTime !== undefined && filter_EndTime !== null)
      url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
    if (sort_SortType === null)
      throw new Error("The parameter 'sort_SortType' cannot be null.");
    else if (sort_SortType !== undefined)
      url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
    if (sort_Ascending === null)
      throw new Error("The parameter 'sort_Ascending' cannot be null.");
    else if (sort_Ascending !== undefined)
      url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
    if (exportType === null)
      throw new Error("The parameter 'exportType' cannot be null.");
    else if (exportType !== undefined)
      url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
    if (exportFormat === null)
      throw new Error("The parameter 'exportFormat' cannot be null.");
    else if (exportFormat !== undefined)
      url_ += "ExportFormat=" + encodeURIComponent("" + exportFormat) + "&";
    if (writeIfEmpty === null)
      throw new Error("The parameter 'writeIfEmpty' cannot be null.");
    else if (writeIfEmpty !== undefined)
      url_ += "WriteIfEmpty=" + encodeURIComponent("" + writeIfEmpty) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetUsageSummary(_response);
    });
  }

  protected processGetUsageSummary(response: AxiosResponse): Promise<UsageSummary> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UsageSummary.fromJS(resultData200);
      return Promise.resolve<UsageSummary>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UsageSummary>(null as any);
  }

  startCsvDownload(filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined, cancelToken?: CancelToken): Promise<StartUsageDownloadResult> {
    let url_ = this.baseUrl + "/api/v1/usage/csv/start?";
    if (filter_CustomerIds === null)
      throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
    else if (filter_CustomerIds !== undefined)
      filter_CustomerIds && filter_CustomerIds.forEach(item => {
        url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_UserIds === null)
      throw new Error("The parameter 'filter_UserIds' cannot be null.");
    else if (filter_UserIds !== undefined)
      filter_UserIds && filter_UserIds.forEach(item => {
        url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_JobIds === null)
      throw new Error("The parameter 'filter_JobIds' cannot be null.");
    else if (filter_JobIds !== undefined)
      filter_JobIds && filter_JobIds.forEach(item => {
        url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_StartTime !== undefined && filter_StartTime !== null)
      url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
    if (filter_EndTime !== undefined && filter_EndTime !== null)
      url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
    if (sort_SortType === null)
      throw new Error("The parameter 'sort_SortType' cannot be null.");
    else if (sort_SortType !== undefined)
      url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
    if (sort_Ascending === null)
      throw new Error("The parameter 'sort_Ascending' cannot be null.");
    else if (sort_Ascending !== undefined)
      url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
    if (exportType === null)
      throw new Error("The parameter 'exportType' cannot be null.");
    else if (exportType !== undefined)
      url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
    if (exportFormat === null)
      throw new Error("The parameter 'exportFormat' cannot be null.");
    else if (exportFormat !== undefined)
      url_ += "ExportFormat=" + encodeURIComponent("" + exportFormat) + "&";
    if (writeIfEmpty === null)
      throw new Error("The parameter 'writeIfEmpty' cannot be null.");
    else if (writeIfEmpty !== undefined)
      url_ += "WriteIfEmpty=" + encodeURIComponent("" + writeIfEmpty) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processStartCsvDownload(_response);
    });
  }

  protected processStartCsvDownload(response: AxiosResponse): Promise<StartUsageDownloadResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = StartUsageDownloadResult.fromJS(resultData200);
      return Promise.resolve<StartUsageDownloadResult>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<StartUsageDownloadResult>(null as any);
  }

  startUsageDownload(filter_CustomerIds?: string[] | undefined, filter_UserIds?: string[] | undefined, filter_JobIds?: string[] | undefined, filter_StartTime?: Date | null | undefined, filter_EndTime?: Date | null | undefined, sort_SortType?: UsageSortType | undefined, sort_Ascending?: boolean | undefined, exportType?: UsageExportType | undefined, exportFormat?: UsageExportFormat | undefined, writeIfEmpty?: boolean | undefined, cancelToken?: CancelToken): Promise<StartUsageDownloadResult> {
    let url_ = this.baseUrl + "/api/v1/usage/download/start?";
    if (filter_CustomerIds === null)
      throw new Error("The parameter 'filter_CustomerIds' cannot be null.");
    else if (filter_CustomerIds !== undefined)
      filter_CustomerIds && filter_CustomerIds.forEach(item => {
        url_ += "Filter.CustomerIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_UserIds === null)
      throw new Error("The parameter 'filter_UserIds' cannot be null.");
    else if (filter_UserIds !== undefined)
      filter_UserIds && filter_UserIds.forEach(item => {
        url_ += "Filter.UserIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_JobIds === null)
      throw new Error("The parameter 'filter_JobIds' cannot be null.");
    else if (filter_JobIds !== undefined)
      filter_JobIds && filter_JobIds.forEach(item => {
        url_ += "Filter.JobIds=" + encodeURIComponent("" + item) + "&";
      });
    if (filter_StartTime !== undefined && filter_StartTime !== null)
      url_ += "Filter.StartTime=" + encodeURIComponent(filter_StartTime ? "" + filter_StartTime.toISOString() : "") + "&";
    if (filter_EndTime !== undefined && filter_EndTime !== null)
      url_ += "Filter.EndTime=" + encodeURIComponent(filter_EndTime ? "" + filter_EndTime.toISOString() : "") + "&";
    if (sort_SortType === null)
      throw new Error("The parameter 'sort_SortType' cannot be null.");
    else if (sort_SortType !== undefined)
      url_ += "Sort.SortType=" + encodeURIComponent("" + sort_SortType) + "&";
    if (sort_Ascending === null)
      throw new Error("The parameter 'sort_Ascending' cannot be null.");
    else if (sort_Ascending !== undefined)
      url_ += "Sort.Ascending=" + encodeURIComponent("" + sort_Ascending) + "&";
    if (exportType === null)
      throw new Error("The parameter 'exportType' cannot be null.");
    else if (exportType !== undefined)
      url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
    if (exportFormat === null)
      throw new Error("The parameter 'exportFormat' cannot be null.");
    else if (exportFormat !== undefined)
      url_ += "ExportFormat=" + encodeURIComponent("" + exportFormat) + "&";
    if (writeIfEmpty === null)
      throw new Error("The parameter 'writeIfEmpty' cannot be null.");
    else if (writeIfEmpty !== undefined)
      url_ += "WriteIfEmpty=" + encodeURIComponent("" + writeIfEmpty) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processStartUsageDownload(_response);
    });
  }

  protected processStartUsageDownload(response: AxiosResponse): Promise<StartUsageDownloadResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = StartUsageDownloadResult.fromJS(resultData200);
      return Promise.resolve<StartUsageDownloadResult>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<StartUsageDownloadResult>(null as any);
  }

  createWebhook(createWebhookDto?: CreateOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhook> {
    let url_ = this.baseUrl + "/api/v1/webhook";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createWebhookDto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processCreateWebhook(_response);
    });
  }

  protected processCreateWebhook(response: AxiosResponse): Promise<OutgoingWebhook> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = OutgoingWebhook.fromJS(resultData201);
      return Promise.resolve<OutgoingWebhook>(result201);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhook>(null as any);
  }

  listWebhooks(isDeleted?: boolean | null | undefined, paginationToken?: string | null | undefined, limit?: number | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookPaginatedResult> {
    let url_ = this.baseUrl + "/api/v1/webhook?";
    if (isDeleted !== undefined && isDeleted !== null)
      url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "paginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListWebhooks(_response);
    });
  }

  protected processListWebhooks(response: AxiosResponse): Promise<OutgoingWebhookPaginatedResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookPaginatedResult.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookPaginatedResult>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookPaginatedResult>(null as any);
  }

  deleteUserWebhooks(cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/webhook/batch";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteUserWebhooks(_response);
    });
  }

  protected processDeleteUserWebhooks(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  deleteUserWebhooksAdmin(userId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/webhook/admin/batch/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteUserWebhooksAdmin(_response);
    });
  }

  protected processDeleteUserWebhooksAdmin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  deleteWebhook(id: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/webhook/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteWebhook(_response);
    });
  }

  protected processDeleteWebhook(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  editWebhook(id: string, dto?: EditOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhook> {
    let url_ = this.baseUrl + "/api/v1/webhook/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processEditWebhook(_response);
    });
  }

  protected processEditWebhook(response: AxiosResponse): Promise<OutgoingWebhook> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhook.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhook>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhook>(null as any);
  }

  getWebhook(id: string, cancelToken?: CancelToken): Promise<OutgoingWebhook> {
    let url_ = this.baseUrl + "/api/v1/webhook/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetWebhook(_response);
    });
  }

  protected processGetWebhook(response: AxiosResponse): Promise<OutgoingWebhook> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhook.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhook>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhook>(null as any);
  }

  deleteWebhookAdmin(userId: string, id: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/webhook/admin/{userId}/{id}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteWebhookAdmin(_response);
    });
  }

  protected processDeleteWebhookAdmin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  editWebhookAdmin(userId: string, id: string, dto?: EditOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhook> {
    let url_ = this.baseUrl + "/api/v1/webhook/admin/{userId}/{id}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processEditWebhookAdmin(_response);
    });
  }

  protected processEditWebhookAdmin(response: AxiosResponse): Promise<OutgoingWebhook> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhook.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhook>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhook>(null as any);
  }

  getWebhookSecret(id: string, cancelToken?: CancelToken): Promise<OutgoingWebhookSecret> {
    let url_ = this.baseUrl + "/api/v1/webhook/secret/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetWebhookSecret(_response);
    });
  }

  protected processGetWebhookSecret(response: AxiosResponse): Promise<OutgoingWebhookSecret> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookSecret.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookSecret>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookSecret>(null as any);
  }

  listUserWebhookHistories(isDeleted?: boolean | null | undefined, paginationToken?: string | null | undefined, limit?: number | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookEventPaginatedResult> {
    let url_ = this.baseUrl + "/api/v1/webhook/history?";
    if (isDeleted !== undefined && isDeleted !== null)
      url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "paginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListUserWebhookHistories(_response);
    });
  }

  protected processListUserWebhookHistories(response: AxiosResponse): Promise<OutgoingWebhookEventPaginatedResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookEventPaginatedResult.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookEventPaginatedResult>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookEventPaginatedResult>(null as any);
  }

  listWebhookHistory(id: string, paginationToken?: string | null | undefined, limit?: number | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookEventPaginatedResult> {
    let url_ = this.baseUrl + "/api/v1/webhook/history/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "paginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListWebhookHistory(_response);
    });
  }

  protected processListWebhookHistory(response: AxiosResponse): Promise<OutgoingWebhookEventPaginatedResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookEventPaginatedResult.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookEventPaginatedResult>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookEventPaginatedResult>(null as any);
  }

  listWebhooksAdmin(userId: string, isDeleted?: boolean | null | undefined, paginationToken?: string | null | undefined, limit?: number | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookPaginatedResult> {
    let url_ = this.baseUrl + "/api/v1/webhook/admin/{userId}?";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    if (isDeleted !== undefined && isDeleted !== null)
      url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "paginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListWebhooksAdmin(_response);
    });
  }

  protected processListWebhooksAdmin(response: AxiosResponse): Promise<OutgoingWebhookPaginatedResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookPaginatedResult.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookPaginatedResult>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookPaginatedResult>(null as any);
  }

  previewExistingWebhookBody(id: string, dto?: EditOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookBody> {
    let url_ = this.baseUrl + "/api/v1/webhook/preview/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processPreviewExistingWebhookBody(_response);
    });
  }

  protected processPreviewExistingWebhookBody(response: AxiosResponse): Promise<OutgoingWebhookBody> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookBody.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookBody>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookBody>(null as any);
  }

  previewWebhookBody(createWebhookDto?: CreateOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookBody> {
    let url_ = this.baseUrl + "/api/v1/webhook/preview";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createWebhookDto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processPreviewWebhookBody(_response);
    });
  }

  protected processPreviewWebhookBody(response: AxiosResponse): Promise<OutgoingWebhookBody> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookBody.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookBody>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookBody>(null as any);
  }

  testExistingWebhook(id: string, dto?: EditOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookSendAttempt> {
    let url_ = this.baseUrl + "/api/v1/webhook/test/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processTestExistingWebhook(_response);
    });
  }

  protected processTestExistingWebhook(response: AxiosResponse): Promise<OutgoingWebhookSendAttempt> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookSendAttempt.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookSendAttempt>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookSendAttempt>(null as any);
  }

  testNewWebhook(createWebhookDto?: CreateOutgoingWebhookRequest | null | undefined, cancelToken?: CancelToken): Promise<OutgoingWebhookSendAttempt> {
    let url_ = this.baseUrl + "/api/v1/webhook/test";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createWebhookDto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processTestNewWebhook(_response);
    });
  }

  protected processTestNewWebhook(response: AxiosResponse): Promise<OutgoingWebhookSendAttempt> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = OutgoingWebhookSendAttempt.fromJS(resultData200);
      return Promise.resolve<OutgoingWebhookSendAttempt>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OutgoingWebhookSendAttempt>(null as any);
  }

  /**
   * Lists the contents of a ZIP file.
   * @param projectId The project id.
   * @param fileId The file id.
   * @param storageType (optional) The storage type. Defaults to Forge.
   * @param allowDeleted (optional) Whether to list a deleted file's contents.
   * @return The list of files contained in the ZIP.
   */
  listZipContents(projectId: string, fileId: string, storageType?: StorageType | undefined, allowDeleted?: boolean | undefined, cancelToken?: CancelToken): Promise<ZipEntryDto[]> {
    let url_ = this.baseUrl + "/api/v1/zip/{projectId}/{fileId}?";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    if (storageType === null)
      throw new Error("The parameter 'storageType' cannot be null.");
    else if (storageType !== undefined)
      url_ += "storageType=" + encodeURIComponent("" + storageType) + "&";
    if (allowDeleted === null)
      throw new Error("The parameter 'allowDeleted' cannot be null.");
    else if (allowDeleted !== undefined)
      url_ += "allowDeleted=" + encodeURIComponent("" + allowDeleted) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListZipContents(_response);
    });
  }

  protected processListZipContents(response: AxiosResponse): Promise<ZipEntryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ZipEntryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ZipEntryDto[]>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ZipEntryDto[]>(null as any);
  }

  /**
   * Extracts the contents of a ZIP file.
   * @param extractRequest (optional) The parameters for the extraction job.
   * @return A list of status objects for the job.
   */
  startExtract(extractRequest?: StartExtractRequest | null | undefined, cancelToken?: CancelToken): Promise<StartExtractResponse[]> {
    let url_ = this.baseUrl + "/api/v1/zip";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(extractRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processStartExtract(_response);
    });
  }

  protected processStartExtract(response: AxiosResponse): Promise<StartExtractResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(StartExtractResponse.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<StartExtractResponse[]>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<StartExtractResponse[]>(null as any);
  }

  /**
   * Gets the status of an extraction job.
   * @param id The job ID.
   * @return The current status of the job.
   */
  status(id: string, cancelToken?: CancelToken): Promise<FileStatus> {
    let url_ = this.baseUrl + "/api/v1/zip/status/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processStatus(_response);
    });
  }

  protected processStatus(response: AxiosResponse): Promise<FileStatus> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FileStatus.fromJS(resultData200);
      return Promise.resolve<FileStatus>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileStatus>(null as any);
  }

  createCustomer(dto?: CreateCustomerRequest | null | undefined, cancelToken?: CancelToken): Promise<CustomerInfo> {
    let url_ = this.baseUrl + "/api/v1/customer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processCreateCustomer(_response);
    });
  }

  protected processCreateCustomer(response: AxiosResponse): Promise<CustomerInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = CustomerInfo.fromJS(resultData201);
      return Promise.resolve<CustomerInfo>(result201);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CustomerInfo>(null as any);
  }

  /**
   * @deprecated
   */
  listCustomers(cancelToken?: CancelToken): Promise<CustomerInfo[]> {
    let url_ = this.baseUrl + "/api/v1/customer";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListCustomers(_response);
    });
  }

  protected processListCustomers(response: AxiosResponse): Promise<CustomerInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(CustomerInfo.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<CustomerInfo[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CustomerInfo[]>(null as any);
  }

  deleteCustomer(id: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/customer/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteCustomer(_response);
    });
  }

  protected processDeleteCustomer(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getCustomer(id: string, cancelToken?: CancelToken): Promise<CustomerInfo> {
    let url_ = this.baseUrl + "/api/v1/customer/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetCustomer(_response);
    });
  }

  protected processGetCustomer(response: AxiosResponse): Promise<CustomerInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CustomerInfo.fromJS(resultData200);
      return Promise.resolve<CustomerInfo>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CustomerInfo>(null as any);
  }

  updateCustomer(id: string, dto?: EditCustomerRequest | null | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/customer/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUpdateCustomer(_response);
    });
  }

  protected processUpdateCustomer(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  heartbeat(cancelToken?: CancelToken): Promise<HealthStatus> {
    let url_ = this.baseUrl + "/api/v1/health";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processHeartbeat(_response);
    });
  }

  protected processHeartbeat(response: AxiosResponse): Promise<HealthStatus> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = HealthStatus.fromJS(resultData200);
      return Promise.resolve<HealthStatus>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<HealthStatus>(null as any);
  }

  getProject(hubId: string | null, projectId: string, storageType?: StorageType | null | undefined, cancelToken?: CancelToken): Promise<Project> {
    let url_ = this.baseUrl + "/api/v1/project/{hubId}/{projectId}?";
    if (hubId === undefined || hubId === null)
      throw new Error("The parameter 'hubId' must be defined.");
    url_ = url_.replace("{hubId}", encodeURIComponent("" + hubId));
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    if (storageType !== undefined && storageType !== null)
      url_ += "storageType=" + encodeURIComponent("" + storageType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetProject(_response);
    });
  }

  protected processGetProject(response: AxiosResponse): Promise<Project> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = Project.fromJS(resultData200);
      return Promise.resolve<Project>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Project>(null as any);
  }

  listAll(includeLegacyHubs?: boolean | undefined, cancelToken?: CancelToken): Promise<Project[]> {
    let url_ = this.baseUrl + "/api/v1/project?";
    if (includeLegacyHubs === null)
      throw new Error("The parameter 'includeLegacyHubs' cannot be null.");
    else if (includeLegacyHubs !== undefined)
      url_ += "includeLegacyHubs=" + encodeURIComponent("" + includeLegacyHubs) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListAll(_response);
    });
  }

  protected processListAll(response: AxiosResponse): Promise<Project[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(Project.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<Project[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Project[]>(null as any);
  }

  listHubs(includeLegacyHubs?: boolean | undefined, cancelToken?: CancelToken): Promise<Hub[]> {
    let url_ = this.baseUrl + "/api/v1/project/hubs?";
    if (includeLegacyHubs === null)
      throw new Error("The parameter 'includeLegacyHubs' cannot be null.");
    else if (includeLegacyHubs !== undefined)
      url_ += "includeLegacyHubs=" + encodeURIComponent("" + includeLegacyHubs) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListHubs(_response);
    });
  }

  protected processListHubs(response: AxiosResponse): Promise<Hub[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(Hub.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<Hub[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Hub[]>(null as any);
  }

  listImages(includeLegacyHubs?: boolean | undefined, cancelToken?: CancelToken): Promise<Project[]> {
    let url_ = this.baseUrl + "/api/v1/project/images?";
    if (includeLegacyHubs === null)
      throw new Error("The parameter 'includeLegacyHubs' cannot be null.");
    else if (includeLegacyHubs !== undefined)
      url_ += "includeLegacyHubs=" + encodeURIComponent("" + includeLegacyHubs) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListImages(_response);
    });
  }

  protected processListImages(response: AxiosResponse): Promise<Project[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(Project.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<Project[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Project[]>(null as any);
  }

  createProjectWiseConfiguration(dto?: CreateProjectWiseConfigurationDto | null | undefined, cancelToken?: CancelToken): Promise<ProjectWiseConfiguration> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/configurations";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processCreateProjectWiseConfiguration(_response);
    });
  }

  protected processCreateProjectWiseConfiguration(response: AxiosResponse): Promise<ProjectWiseConfiguration> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = ProjectWiseConfiguration.fromJS(resultData201);
      return Promise.resolve<ProjectWiseConfiguration>(result201);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseConfiguration>(null as any);
  }

  createProjectWiseCredential(dto?: CreateProjectWiseCredentialDto | null | undefined, cancelToken?: CancelToken): Promise<ProjectWiseCredential> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/credentials";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processCreateProjectWiseCredential(_response);
    });
  }

  protected processCreateProjectWiseCredential(response: AxiosResponse): Promise<ProjectWiseCredential> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = ProjectWiseCredential.fromJS(resultData201);
      return Promise.resolve<ProjectWiseCredential>(result201);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseCredential>(null as any);
  }

  listProjectWiseCredentials(paginationToken?: string | null | undefined, limit?: number | undefined, cancelToken?: CancelToken): Promise<ProjectWiseCredentialPaginatedResult> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/credentials?";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "PaginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListProjectWiseCredentials(_response);
    });
  }

  protected processListProjectWiseCredentials(response: AxiosResponse): Promise<ProjectWiseCredentialPaginatedResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseCredentialPaginatedResult.fromJS(resultData200);
      return Promise.resolve<ProjectWiseCredentialPaginatedResult>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseCredentialPaginatedResult>(null as any);
  }

  deleteProjectWiseConfiguration(id: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/configurations/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteProjectWiseConfiguration(_response);
    });
  }

  protected processDeleteProjectWiseConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getProjectWiseConfiguration(id: string, allowDeleted?: boolean | undefined, cancelToken?: CancelToken): Promise<ProjectWiseConfiguration> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/configurations/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (allowDeleted === null)
      throw new Error("The parameter 'allowDeleted' cannot be null.");
    else if (allowDeleted !== undefined)
      url_ += "allowDeleted=" + encodeURIComponent("" + allowDeleted) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetProjectWiseConfiguration(_response);
    });
  }

  protected processGetProjectWiseConfiguration(response: AxiosResponse): Promise<ProjectWiseConfiguration> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseConfiguration.fromJS(resultData200);
      return Promise.resolve<ProjectWiseConfiguration>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseConfiguration>(null as any);
  }

  updateProjectWiseConfiguration(id: string, dto?: UpdateProjectWiseConfigurationDto | null | undefined, cancelToken?: CancelToken): Promise<ProjectWiseConfiguration> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/configurations/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUpdateProjectWiseConfiguration(_response);
    });
  }

  protected processUpdateProjectWiseConfiguration(response: AxiosResponse): Promise<ProjectWiseConfiguration> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseConfiguration.fromJS(resultData200);
      return Promise.resolve<ProjectWiseConfiguration>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseConfiguration>(null as any);
  }

  deleteProjectWiseCredential(id: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/credentials/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteProjectWiseCredential(_response);
    });
  }

  protected processDeleteProjectWiseCredential(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getProjectWiseCredential(id: string, allowDeleted?: boolean | undefined, cancelToken?: CancelToken): Promise<ProjectWiseCredential> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/credentials/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (allowDeleted === null)
      throw new Error("The parameter 'allowDeleted' cannot be null.");
    else if (allowDeleted !== undefined)
      url_ += "allowDeleted=" + encodeURIComponent("" + allowDeleted) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetProjectWiseCredential(_response);
    });
  }

  protected processGetProjectWiseCredential(response: AxiosResponse): Promise<ProjectWiseCredential> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseCredential.fromJS(resultData200);
      return Promise.resolve<ProjectWiseCredential>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseCredential>(null as any);
  }

  updateProjectWiseCredential(id: string, dto?: UpdateProjectWiseCredentialDto | null | undefined, cancelToken?: CancelToken): Promise<ProjectWiseCredential> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/credentials/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUpdateProjectWiseCredential(_response);
    });
  }

  protected processUpdateProjectWiseCredential(response: AxiosResponse): Promise<ProjectWiseCredential> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseCredential.fromJS(resultData200);
      return Promise.resolve<ProjectWiseCredential>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseCredential>(null as any);
  }

  getProjectWiseCredentialSecret(id: string, cancelToken?: CancelToken): Promise<ProjectWiseCredentialWithSecret> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/secret/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetProjectWiseCredentialSecret(_response);
    });
  }

  protected processGetProjectWiseCredentialSecret(response: AxiosResponse): Promise<ProjectWiseCredentialWithSecret> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseCredentialWithSecret.fromJS(resultData200);
      return Promise.resolve<ProjectWiseCredentialWithSecret>(result200);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("A server side error occurred.", status, _responseText, _headers, result403);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseCredentialWithSecret>(null as any);
  }

  listProjectWiseConfigurations(paginationToken?: string | null | undefined, limit?: number | undefined, cancelToken?: CancelToken): Promise<ProjectWiseConfigurationPaginatedResult> {
    let url_ = this.baseUrl + "/api/v1/settings/pw/config?";
    if (paginationToken !== undefined && paginationToken !== null)
      url_ += "PaginationToken=" + encodeURIComponent("" + paginationToken) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListProjectWiseConfigurations(_response);
    });
  }

  protected processListProjectWiseConfigurations(response: AxiosResponse): Promise<ProjectWiseConfigurationPaginatedResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectWiseConfigurationPaginatedResult.fromJS(resultData200);
      return Promise.resolve<ProjectWiseConfigurationPaginatedResult>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectWiseConfigurationPaginatedResult>(null as any);
  }

  listStorageTypes(cancelToken?: CancelToken): Promise<string[]> {
    let url_ = this.baseUrl + "/api/v1/settings/types";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processListStorageTypes(_response);
    });
  }

  protected processListStorageTypes(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(item);
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<string[]>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
  }

  getUserAccounts(cancelToken?: CancelToken): Promise<UserAccount[]> {
    let url_ = this.baseUrl + "/api/v1/user/accounts";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetUserAccounts(_response);
    });
  }

  protected processGetUserAccounts(response: AxiosResponse): Promise<UserAccount[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserAccount.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UserAccount[]>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserAccount[]>(null as any);
  }

  getUserInfo(cancelToken?: CancelToken): Promise<UserBase> {
    let url_ = this.baseUrl + "/api/v1/user";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetUserInfo(_response);
    });
  }

  protected processGetUserInfo(response: AxiosResponse): Promise<UserBase> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserBase.fromJS(resultData200);
      return Promise.resolve<UserBase>(result200);

    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserBase>(null as any);
  }

  userWebhookCallback(webhookBody?: GDPRWebhook | null | undefined, signature?: string | undefined, cancelToken?: CancelToken): Promise<GDPRWebhookResponse> {
    let url_ = this.baseUrl + "/api/v1/user/gdprcallback";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(webhookBody);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "x-adsk-signature": signature !== undefined && signature !== null ? "" + signature : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUserWebhookCallback(_response);
    });
  }

  protected processUserWebhookCallback(response: AxiosResponse): Promise<GDPRWebhookResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GDPRWebhookResponse.fromJS(resultData200);
      return Promise.resolve<GDPRWebhookResponse>(result200);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GDPRWebhookResponse>(null as any);
  }

  adskWebhookCallback(webhookBody?: WebhookBody | null | undefined, signature?: string | null | undefined, userId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/webhook/callback?";
    if (userId !== undefined && userId !== null)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(webhookBody);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "x-adsk-signature": signature !== undefined && signature !== null ? "" + signature : "",
        "Content-Type": "application/json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processAdskWebhookCallback(_response);
    });
  }

  protected processAdskWebhookCallback(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: {
  [key: string]: any;
}, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}